export default "__VITE_ASSET__By2fOG23__"